import tw from "twin.macro"

// import Sun from "icons/Sun"
import { IntroText } from "styles/Text"
import Drizzle from "icons/weather/Drizzle"
import Thunderstorm from "icons/weather/Thunderstorm"
import Rain from "icons/weather/Rain"
import Clear from "icons/weather/Clear"
import FewClouds from "icons/weather/FewClouds"
import Cloudy from "icons/weather/Cloudy"
import Atmosphere from "icons/Atmosphere"

enum WeatherType {
  DRIZZLE = "Drizzle",
  THUNDERSTORM = "Thunderstorm",
  RAIN = "Rain",
  CLEAR = "Clear",
  CLOUDS = "Clouds",
}

interface WeatherWidgetProps {
  type: string
  temp: string | number
  typeId: string | number
}

const WeatherIcon = ({ type, typeId }) => {
  switch (type) {
    case WeatherType.DRIZZLE: {
      return <Drizzle />
    }
    case WeatherType.THUNDERSTORM: {
      return <Thunderstorm />
    }
    case WeatherType.RAIN: {
      return <Rain />
    }
    case WeatherType.CLEAR: {
      return <Clear />
    }
    case WeatherType.CLOUDS: {
      if (typeId === 801) return <FewClouds />
      return <Cloudy />
    }
    default: {
      return <Atmosphere />
    }
  }
}

const WeatherWidget = (props: WeatherWidgetProps) => {
  const { typeId, type, temp } = props

  if (!type) return null

  return (
    <div tw="inline-flex items-center space-x-3">
      <WeatherIcon type={type} typeId={typeId} />

      <IntroText tw="leading-none md:-mt-1" as="span">
        {temp}°C
      </IntroText>
    </div>
  )
}

export default WeatherWidget
